export const RESET_PRODUCT = "RESET_PRODUCT";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_PRODUCTS_SELECTED = "SET_PRODUCTS_SELECTED";
export const SET_PRODUCTS_SELECTED_ALL = "SET_PRODUCTS_SELECTED_ALL";
export const REMOVE_PRODUCTS_SELECTED = "REMOVE_PRODUCTS_SELECTED";
